/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { TEMP_STORAGE_KEYS } from '../../../constants/main';

export class API {
  constructor(options) {
    const defaults = {
      env: 'production'
    };

    this.config = {
      ...defaults,
      ...options
    };

    this._token = window.localStorage.getItem(TEMP_STORAGE_KEYS.TOKEN) || '';
    this._refreshToken = window.localStorage.getItem(TEMP_STORAGE_KEYS.REFRESH_TOKEN) || '';
    this._cancelations = {};
  }

  reset() {
    this._token = '';
    this._refreshToken = '';
    this._cancelations = {};
  }

  /**
   * Creates an API to abort requests.
   * Provide a `cancelToken` if the request candidate to be aborted is created using the `XMLHttpRequest (XHR)` object.
   * Otherwise for requests created using the `Fetch` API, do not provide `cancelToken` argument.
   * See https://developer.mozilla.org/en-US/docs/Web/API/AbortController for more details on how to abort requests using the `AbortController` interface.
   *
   * @param {String} [cancelToken] A unique token to identify which request to abort.
   * @return {Object} The appropriate API to use on each case for aborting a request.
   */
  abortController(cancelToken) {
    let returnable;

    if (cancelToken) {
      returnable = {
        abort: () => {
          if (this._cancelations[cancelToken]) {
            this._cancelations[cancelToken]();
            this._cancelations[cancelToken] = null;
            delete this._cancelations[cancelToken];
          }
        }
      };
    } else {
      try {
        returnable = new AbortController();
      } catch (err) {
        // If `AbortController` is not supported, return similar API so that it fails silently.
        returnable = {
          abort: () => {},
          signal: null
        };
      }
    }

    return returnable;
  }
}

/**
 * Public API methods
 */
const publicMethods = {

};

const api = new API();

Object.entries(publicMethods).forEach(([key, value]) => API.prototype[key] = (...args) => value.default(...args)(api));

export default api;
